export const newBerlin600 = [

  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/67c2460e553e09ba37f7f570412bbb137c3db490de3879d1aabaca0a.jpg",
    type: "Room",
    available: "From 1 December",
    title: "Room for rent in shared house in Tempelhof, Berlin",
    rent: "395 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/390914",
    id: "berlin1"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/e1460fdabfda00c7bd7a3860f7a1599f146865d9914615d0e1bbb12d.jpg",
    type: "Room",
    available: "From 31 December",
    title: "Rooms for rent in apartment with 13 bedrooms in Berlin",
    rent: "420 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/595360",
    id: "berlin2"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/3e24528e40fd159ea6f58a0c5a3ce91a416a1efa15752c0890af0af5.jpg",
    type: "Room",
    available: "From 31 December",
    title: "Rooms for rent in apartment with 13 bedrooms in Berlin",
    rent: "450 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/595359",
    id: "berlin3"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/a903ea77344c263592a3a4d63cb70daf0756295a282a2fb42575d7d7.jpg",
    type: "Room",
    available: "From 24 December",
    title: "Room for rent in apartment with 2 bedrooms in Berlin",
    rent: "480 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/623889",
    id: "berlin4"
  },
  {
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/12785243cb29cf95ae5ad624023a2a7d20b87f7d37f3f085005fc3fe.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Room in shared apartment in Berlin",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/591972",
    id: "berlin5"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/677e18e352d5bf88749aa398824ac0a00c6b64b3dfe2b1eae8186eb9.jpg",
    type: "Room",
    available: "From 2 October",
    title: "Room for rent in apartment with 6 bedrooms",
    rent: "500 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/160735",
    id: "berlin6"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/f0635dccd908c88c27c85543f642823b4518660d478bb9c1ced816cc.jpg",
    type: "Room",
    available: "From 28 December",
    title: "Room in 4-bedroom apartment in Treptow-Köpenick, Berlin",
    rent: "509 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/207990",
    id: "berlin7"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/05c13c9ee35eb6e174776521f29210c840f68663eb713ad75607ee63.jpg",
    type: "Room",
    available: "From 10 August",
    title: "Cozy room in apartment with 4 bedrooms in Spandau, Berlin",
    rent: "525 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/162842",
    id: "berlin8"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/01cff3087567421c4033d956b652ddbb0a44b584d9d03793d3dba8ad.jpg",
    type: "Room",
    available: "From 27 December",
    title: "Room for rent in apartment with 5 bedrooms in Berlin",
    rent: "530 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/610713",
    id: "berlin9"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/57c0319ae3f48011dacc2316c8ab09fe07455d5937b983473eda2f8b.jpg",
    type: "Room",
    available: "From 28 December",
    title: "Room for rent in apartment with 5 bedrooms in Berlin",
    rent: "530 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/610711",
    id: "berlin10"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/80ba9fa1e5797dfd8d146ba636e01ca52471d7f7015f20155299507e.jpg",
    type: "Room",
    available: "From 16 October",
    title: "Snug room for rent, apartment with 3 bedrooms, Neukölln",
    rent: "540 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/370072",
    id: "berlin11"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/21c28bf63e22b9d468dde4db6bdeee5582e6f65779339fe8468dc497.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Spacious room in apartment with 3 bedrooms in Berlin",
    rent: "550 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/295612",
    id: "berlin12"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/0e568e287872c01cdc0117f8c7c8c4550b319904c33113c385b20baa.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Sunny room in apartment with 3 bedrooms in Berlin",
    rent: "550 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/295611",
    id: "berlin13"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/b0d5b76315a59bdce7a63f22c5e00492b625d68bbd04a738bfae6f68.jpg",
    type: "Room",
    available: "From 1 September",
    title: "Welcoming room in 3-bedroom apartment in Lichtenberg, Berlin",
    rent: "550 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/164609",
    id: "berlin14"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/8343e93cb778d764a191246c4bfa246d7a460be7ab1e5f527cc9179a.jpg",
    type: "Room",
    available: "From 29 September",
    title: "Welcoming room in 3-bedroom apartment in Lichtenberg, Berlin",
    rent: "550 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/146077",
    id: "berlin15"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/6eb3d4811a2d685b01a5bff9c93cf0b3154252ed7d06394b7081843d.jpg",
    type: "Room",
    available: "From 26 December",
    title: "Cozy room for rent in 4-bedroom apartment in Spandau, Berlin",
    rent: "550 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/254759",
    id: "berlin16"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/dc189a550a4345ce1e7e050f8fbd2f2e661ba6019a24e61bcbe669bc.jpg",
    type: "Room",
    available: "From 30 December",
    title: "Rooms for rent in apartment with 5 rooms Schöneberg, Berlin",
    rent: "550 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/598883",
    id: "berlin17"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/2b81215bba9ee27284f07d80a898ef08eba99bb4b84a19e4dc36460a.jpg",
    type: "Room",
    available: "From 30 December",
    title: "Rooms for rent in apartment with 5 rooms Schöneberg, Berlin",
    rent: "550 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/598885",
    id: "berlin18"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 6 August",
    title: "Cozy room in apartment with 4 bedrooms in Spandau, Berlin",
    rent: "575 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/162841",
    id: "berlin19"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 3 December",
    title: "Room in 2-bedroom apartment for rent in Charlottenburg",
    rent: "590 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/270141",
    id: "berlin20"
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 30 December",
    title: "Modern studio to rent in trendy Friedrichshain",
    rent: "595 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:studios/279065",
    id: "berlin21"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 3 December",
    title: "Room in 2-bedroom apartment in Mitte",
    rent: "598 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/261926",
    id: "berlin22"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 September",
    title: "Studio room in apartment with 3 bedrooms in Berlin",
    rent: "599 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/295613",
    id: "berlin23"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 September",
    title: "Charming room for rent in Wuhlheide, Berlin",
    rent: "600 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/370328",
    id: "berlin24"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 24 September",
    title: "Sunny room in 3-bedroom apartment in Lichtenberg, Berlin",
    rent: "600 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/145947",
    id: "berlin25"
  },
  {
    type: "Room",
    available: "From 1 November",
    title: "Room in shared apartment in Berlin",
    rent: "600 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/599425",
    id: "berlin26"
  },
  {
    type: "Studio",
    available: "From 1 December",
    title: "Studio apartment in Berlin",
    rent: "600 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:studios/591925",
    id: "berlin27"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 16 December",
    title: "Spacious room in apartemtn with 2 bedrooms in Schöneberg",
    rent: "600 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/340303",
    id: "berlin28"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 16 December",
    title: "Room for rent in apartment with 4 bedrooms in Treptow",
    rent: "609 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/393435",
    id: "berlin29"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 28 December",
    title: "Furnished room in shared apartment, Treptow-Köpenick, Berlin",
    rent: "609 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/275127",
    id: "berlin30"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 28 October",
    title: "Ample room in 2-bedroom apartment in Neukölln, Berlin",
    rent: "630 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/125950",
    id: "berlin31"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 October",
    title: "Charming room for rent, apartment with 3 bedrooms, Neukölln",
    rent: "640 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/370073",
    id: "berlin32"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 28 December",
    title: "Room for rent in 3-bedroom apartment in Friedrichshain",
    rent: "649 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/153228",
    id: "berlin33"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 30 June",
    title: "Room for rent in apartment with 4 bedrooms in Berlin",
    rent: "650 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/602477",
    id: "berlin34"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 28 October",
    title: "Light room in 2-bedroom apartment in Neukölln, Berlin",
    rent: "650 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/125949",
    id: "berlin35"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 28 December",
    title: "Room for rent in apartment with 4 bedrooms in Wedding",
    rent: "650 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/392051",
    id: "berlin36"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 October",
    title: "Large room for rent, apartment with 3 bedrooms, Neukölln",
    rent: "660 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/370074",
    id: "berlin37"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 28 December",
    title: "Bright room in apartment with 2 bedrooms in Pankow, Berlin",
    rent: "675 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/317714",
    id: "berlin38"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 16 August",
    title: "Cute room for rent in apartment with 2 bedrooms in Schönow",
    rent: "680 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/360671",
    id: "berlin39"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 September",
    title: "Rooms for rent in apartment with 2 bedrooms in Berlin",
    rent: "680 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/606371",
    id: "berlin40"
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 1 September",
    title: "Studio apartment for rent Friedenau, Berlin",
    rent: "690-860 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:studios/147395",
    id: "berlin41"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 12 September",
    title: "Room in apartment with 4 bedrooms in Spandau, Berlin",
    rent: "690 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/300075",
    id: "berlin42"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 October",
    title: "Room in apartment with 4 bedrooms in Spandau, Berlin",
    rent: "690 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/300073",
    id: "berlin43"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 14 July",
    title: "Room for rent in apartment with 4 bedrooms in Berlin",
    rent: "700 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/565190",
    id: "berlin44"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 August",
    title: "Room for rent in apartment with 4 bedrooms in Berlin",
    rent: "700 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/602479",
    id: "berlin45"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 August",
    title: "Room for rent in apartment with 4 bedrooms in Berlin",
    rent: "700 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/565189",
    id: "berlin46"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 29 September",
    title: "Room for rent in apartment with 4 bedrooms in Berlin",
    rent: "700 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/602468",
    id: "berlin47"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 29 September",
    title: "Room for rent in apartment with 4 bedrooms in Berlin",
    rent: "700 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/602480",
    id: "berlin48"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 16 October",
    title: "Room for rent in apartment with 4 bedrooms in Berlin",
    rent: "700 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/602469",
    id: "berlin49"
  },
  {
    type: "Room",
    available: "From 28 October",
    title: "Rooms for rent in apartment with 1 bedroom in Berlin",
    rent: "700 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/683911",
    id: "berlin50"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 December",
    title: "Room for rent in apartment with 4 bedrooms in Berlin",
    rent: "700 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/602470",
    id: "berlin51"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 December",
    title: "Beautiful room for rent in Wuhlheide, Berlin",
    rent: "700 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/370327",
    id: "berlin52"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 August",
    title: "Room for rent in 3-bedroom apartment in Mitte, Berlin",
    rent: "750 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/358689",
    id: "berlin53"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 September",
    title: "Room for rent in 3-bedroom apartment in Mitte, Berlin",
    rent: "750 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/357167",
    id: "berlin54"
  },
  {
    verified: "CHECKED",
    type: "Studio",
    available: "From 1 October",
    title: "Modern studio apartment for rent in Stieglitz, Berlin",
    rent: "750 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:studios/145994",
    id: "berlin55"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 November",
    title: "Room for rent in 3-bedroom apartment in Mitte, Berlin",
    rent: "750 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/358690",
    id: "berlin56"
  },
  {
    type: "Studio",
    available: "From 31 December",
    title: "Studio in Berlin",
    rent: "750 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:studios/511568",
    id: "berlin57"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 6 October",
    title: "Rooms for rent in apartment with 3 bedrooms in Berlin",
    rent: "797 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/452809",
    id: "berlin58"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 August",
    title: "Two cozy rooms with private bathroom for rent in shared flat",
    rent: "800 €",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/berlin/for-rent:rooms/623126",
    id: "berlin59"
  },
];
